import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import categ from '../assets/images/cate.jpeg';
import MainDashHaader from '../Pages/MainDashHaader';

import women from '../assets/images/women.jpg';
import u1 from '../assets/images/u1.jfif';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const SubCategoriesProduct = (props)=> {

    const [CategoriesName , setCategoriesname] = useState({})

    const [SliderPhoto , setSliderPhoto] = useState([])
    const [order , setorder] = useState([])
    const [piece , setpiece] = useState([])
    const [total , settotal] = useState([])
    const [mainUser , setmainUser] = useState({})
    const [data , setdata] = useState([])

    // categoriesName subcategories

    useEffect(() =>{

        window.scrollTo(0, 0)

        if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))

        console.log( props.match.params);
        let Categoriesname = props.match.params ;
        setCategoriesname(Categoriesname)

        
        fetch("https://student1stop-backend-vercel.vercel.app/AllUserCreatebookusecourse",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res=>res.json())
        .then(res2=>{
            const f = res2.filter((res3,f)=>res3.UserId === JSON.parse(localStorage.getItem("user main"))._id)
        console.log("ddwdwd",res2)
     setdata(f.reverse())
        })

        fetch("https://student1stop-backend-vercel.vercel.app/AllUserCheckoutData",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res181=>res181.json())
        .then(res191=>{
            let g = []
            let p1 = []
            let t1 = []
            res191.map((res11,i)=>{
                if(res11.UserId){
                    if(res11.UserId === JSON.parse(localStorage.getItem("user main"))._id){
                        g.push(res11)
                    }
                }
            })
            console.log(g)

            g.map((res5,j)=>{
                let p = 0
                let t = res5.DeliveryCharges
                res5.Order.map((res15,i)=>{
                    p +=res15.Pieces  
                    t +=res15.Total_Product_Price  
                })
                p1[j] = p
                t1[j] = t
            })
            console.log(p1,t1,order)
            setpiece(p1)
            settotal(t1)
            setorder(g)
            })

        fetch("https://student1stop-backend-vercel.vercel.app/slider-photo",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res=>res.json())
        .then(res1=>{
            // console.log(res1[0]);
            setSliderPhoto(res1)
        
        })


        
},[])

const setMangeOrder = (data , i) =>{
    localStorage.setItem("User Order Details", JSON.stringify(data))
    props.history.push("/user/dashboard/order-detail")
}


const deleteProduct = (id,i) =>{
    fetch("/AllUserCreateDisbookusecourse/"+id ,{
      method: "DELETE" , 
      headers: {
        "Content-Type" : "application/json" ,
      }
    })
    .then(res=>res.json())
    .then(res2=>{
      const newData = data.filter(data=> data._id !== res2._id)
      setdata(newData)
    })
  }
  
const setfjgkfg = (data) =>{
    localStorage.setItem("Main USer Data For Detail" , JSON.stringify(data))
  props.history.push("/main-user-detail")
  }
  

        return (
            <div>
                     {data.length === 0&& data.length === 0?
                        <Loader
        type="Puff"
        color="#00BFFF"
        height={100}
        width={100}
        timeout={10000} 
        className="loader-1"
      /> 
      :""
}
<center>
            <div className="pop-up-1 dis-off" id="myDi">
                <h1>Product Updated in Cart</h1>
            </div> 
        </center>
               

                <div className="site-section">
                    <div className="container-fuild" style={{width : "97%" , margin : "0px auto"}}>

                        <div className="row mb-5">
                   


                <br/>
                <br/>
               
                  <div className="col-xl-8 order-2 col-lg-8 col-md-8">
                    <table className="table table-hover" style={{background : "white" , borderRadius : "10px"}}>
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col" colSpan="2">Main Cate</th>
                          <th scope="col" colSpan="2">Sub Cate</th>
                          <th scope="col" colSpan="2">Sub Sub Cate</th>
                          <th scope="col" colSpan="2">Book Name</th>
                          <th scope="col" colSpan="2">Actual Price</th>
                          <th scope="col" colSpan="2">Price Cut</th>
                          <th scope="col" colSpan="3">Book Condition</th>
                          {/* <th scope="col" colSpan="2">User Details</th>
                          <th scope="col">Change</th> */}
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                        data.map((res,i)=>{
                              return <>
                              <tr key={i}>
                                        <th>{i+1}</th>
                                        <td  colSpan="2">{res.MainCategories}</td>
                                        <td  colSpan="2">{res.SubCategories}</td>
                                        <td  colSpan="2">{res.SubSubCategories}</td>
                                        <td  colSpan="2">
                                            {res.BookName.map((res1,j)=>{
                                                return (
                                                    <>{res1} <br /> </>
                                                )
                                            })}
                                        </td>
                                        <td  colSpan="2">
                                        {res.BookActualPrice.map((res1,j)=>{
                                                return (
                                                    <>Rs : {res1} <br /> </>
                                                )
                                            })}
                                            </td>
                                        <td  colSpan="2">
                                        {res.BookDisPrice.map((res1,j)=>{
                                                return (
                                                    <>Rs : {res1} <br /> </>
                                                )
                                            })}
                                            </td>
                                        <td  colSpan="2" >
                                        {res.BookCondition.map((res1,j)=>{
                                                return (
                                                    <>{res1} <br /> </>
                                                )
                                            })}
                                            </td>
                                       

                                            {/* <td colSpan="2" > <button onClick={()=>setfjgkfg(res)}  style={{border :  "none" ,color : "skyblue" , borderRadius : "10px"}}>Click For Details</button> </td> */}

                                          
                                        <td colSpan="2" >
                                        <DeleteForeverIcon style={{border : "3px solid #e7acac" , borderRadius : "10px" }} onClick={()=>deleteProduct(res._id,i)}/>
                                        </td>
                                    </tr>
                                   <tr>

                                        {/* {res.BookPhoto.map((res1,j)=>{
                                            return (
                                                <td>
                                                <img src={res1} alt="" style={{width : "400px" , height : "300px"}} /> 
                                                 </td> 
                                                )
                                            })} 
                                            */}
                                   </tr>
                                    </>
                          })
                      }
                     

                      {
                        data.length === 0 
                        ? 
                        <tr>
                          <th scope="col" colSpan="10" style={{textAlign : "center"}}>No data for showing</th>
                        </tr>
                        :
                         ""
                      }
                      <tr>
                      <th scope="col"></th>
                          <th scope="col" colSpan="2">Main Cate</th>
                          <th scope="col" colSpan="2">Sub Cate</th>
                          <th scope="col" colSpan="2">Sub Sub Cate</th>
                          <th scope="col" colSpan="2">Book Name</th>
                          <th scope="col" colSpan="2">Actual Price</th>
                          <th scope="col" colSpan="2">Price Cut</th>
                          <th scope="col" colSpan="3">Book Condition</th>
                          {/* <th scope="col" colSpan="2">User Details</th>
                          <th scope="col">Change</th> */}
                          <th scope="col">Action</th>
                        </tr>
                      <tr>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                        {/* <tbody>
                      {
                        data.map((res,i)=>{
                              return <>
                                   <tr>

                                        {res.BookPhoto.map((res1,j)=>{
                                            return (
                                                <td>
                                                <img src={res1} alt="" style={{width : "400px" , height : "300px"}} /> 
                                            </td>
                                                )
                                            })}
                                   </tr>
                                    </>
                          })
                      }
                      </tbody>  */}
                    </table>
                     
                  
     </div>

                            <MainDashHaader />

                        </div>







                        

                    </div>
                </div>
            </div>
        )
    }



export default SubCategoriesProduct;